module.exports = __webpack_public_path__ + "img/FAV_0085.abf7bcc1.jpg";